import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../api';

function avatarTransform(pos, zoom) {
  const [x, y] = (!pos || pos === '50% 50%' ? '0% 0%' : pos).replace(/%/g, '').split(' ').map(Number);
  return `translate(${isNaN(x) ? 0 : x}%, ${isNaN(y) ? 0 : y}%) scale(${zoom || 1})`;
}

// Emoji icons render as different glyphs (or not at all) between Windows
// desktop browsers, Android and iOS — inline SVGs render identically everywhere.
const IconPhone = ({ size = 16, color = '#ef4444' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color}><path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1C10.6 21 3 13.4 3 4c0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.3 0 .7-.2 1L6.6 10.8z"/></svg>
);
const IconEmail = ({ size = 16, color = '#1f2937' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="4" width="20" height="16" rx="2" /><path d="M2 6l10 7 10-7" />
  </svg>
);
const IconWebsite = ({ size = 16, color = '#1f2937' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" /><path d="M2 12h20M12 2a15.3 15.3 0 0 1 0 20M12 2a15.3 15.3 0 0 0 0 20" />
  </svg>
);
const IconWhatsApp = ({ size = 16, color = '#25D366' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color}><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 00-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
);
const IconFacebook = ({ size = 16, color = '#1877F2' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color}><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
);
const IconInstagram = ({ size = 16 }) => {
  const gid = 'ig-grad-' + Math.random().toString(36).slice(2);
  return (
    <svg width={size} height={size} viewBox="0 0 24 24">
      <defs><linearGradient id={gid} x1="0" y1="1" x2="1" y2="0">
        <stop offset="0%" stopColor="#FEDA75" /><stop offset="25%" stopColor="#FA7E1E" /><stop offset="50%" stopColor="#D62976" /><stop offset="75%" stopColor="#962FBF" /><stop offset="100%" stopColor="#4F5BD5" />
      </linearGradient></defs>
      <path fill={`url(#${gid})`} d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
    </svg>
  );
};
const IconAddContact = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="12" fill="#ffffff" fillOpacity="0.22" />
    <circle cx="12" cy="10" r="3" fill="#ffffff" />
    <path d="M6.2 18.2c0-2.6 2.6-4.2 5.8-4.2s5.8 1.6 5.8 4.2" fill="#ffffff" />
  </svg>
);
const SOCIAL_ICONS = {
  website: <IconWebsite />, whatsapp: <IconWhatsApp />, facebook: <IconFacebook />, instagram: <IconInstagram />,
};
const SOCIAL_LABELS = {
  website: 'אתר', whatsapp: 'וואטסאפ', facebook: 'פייסבוק', instagram: 'אינסטגרם',
};

// Community Group's own brand colors (from the logo: teal mountain, orange
// sunset) — the same for every card regardless of project.
const COMMUNITY_THEME = { primary: '#1F8A8C', accent: '#F5941F', pageBg: 'radial-gradient(circle at 20% 15%, #2fa3a1 0%, #1F8A8C 45%, #d97b1f 100%)' };
function getTheme() {
  return COMMUNITY_THEME;
}

function buildLinkHref(type, raw) {
  const val = (raw || '').trim();
  if (!val) return null;
  if (type === 'whatsapp') {
    let digits = val.replace(/\D/g, '');
    if (digits.startsWith('0')) digits = '972' + digits.slice(1);
    return `https://wa.me/${digits}`;
  }
  return /^https?:\/\//i.test(val) ? val : `https://${val}`;
}

export default function CompanyCard() {
  const { slug } = useParams();
  const [card, setCard] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    api.get(`/portal/card/company/${slug}`).then(r => setCard(r.data)).catch(() => setErr(true));
  }, [slug]);

  // The app's global body background (#f0f2f5) can peek around this page on
  // some viewports (mobile browser chrome resizing 100vh, etc.) — paint the
  // body itself so no gray ever shows through.
  useEffect(() => {
    const prevBg = document.body.style.background;
    document.body.style.background = COMMUNITY_THEME.pageBg;
    return () => { document.body.style.background = prevBg; };
  }, []);

  if (err) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: COMMUNITY_THEME.pageBg, fontFamily: 'Heebo, Arial, sans-serif' }}>
      <div style={{ color: '#6b7280' }}>הכרטיס לא נמצא</div>
    </div>
  );
  if (!card) return null;

  const links = card.social_links || [];
  const theme = getTheme(card.project_name);
  const linkRow = { display: 'flex', alignItems: 'center', gap: 12, padding: '13px 0px 13px 16px', borderRadius: 14, background: '#f8fafc', color: '#1f2937', textDecoration: 'none', fontSize: '0.9rem', border: '1px solid #eef1f5' };
  const iconBubble = { width: 30, height: 30, borderRadius: '50%', background: '#eef2ff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.95rem', flexShrink: 0 };

  return (
    <div style={{
      minHeight: '100vh', background: theme.pageBg,
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24, fontFamily: 'Heebo, Arial, sans-serif', direction: 'rtl',
    }}>
      <div style={{ width: '100%', maxWidth: 400, borderRadius: 28, overflow: 'hidden', boxShadow: '0 20px 60px rgba(0,0,0,0.35)', background: 'white' }}>
        <div style={{ background: `linear-gradient(225deg,${theme.primary},${theme.accent})`, padding: '28px 24px 60px', textAlign: 'center', position: 'relative' }}>
          {card.logo_url && (
            <div style={{
              width: 128, height: 128, borderRadius: '50%', overflow: 'hidden', background: 'white',
              position: 'absolute', left: '50%', bottom: -64, transform: 'translateX(-50%)',
              border: '4px solid white', boxShadow: '0 4px 14px rgba(0,0,0,0.2)',
              display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16, boxSizing: 'border-box',
            }}>
              <img src={card.logo_url} alt="" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
            </div>
          )}
        </div>

        <div style={{ padding: `${card.logo_url ? 76 : 28}px 28px 32px`, textAlign: 'center' }}>
          <div style={{ fontWeight: 700, fontSize: '1.35rem', color: '#1f2937' }}>{card.manhelet_name}</div>
          {card.title && <div style={{ fontSize: '0.9rem', color: theme.accent, fontWeight: 600, marginTop: 4 }}>{card.title}</div>}

          <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginTop: 26 }}>
            {card.phone && (
              <a href={`tel:${card.phone}`} style={linkRow}>
                <span dir="ltr">{card.phone}</span> <span style={{ ...iconBubble, marginInlineStart: 'auto' }}><IconPhone /></span>
              </a>
            )}
            {card.email && (
              <a href={`mailto:${card.email}`} style={linkRow}>
                <span dir="ltr">{card.email}</span> <span style={{ ...iconBubble, marginInlineStart: 'auto' }}><IconEmail /></span>
              </a>
            )}
            {links.map(l => (
              <a key={l.type} href={buildLinkHref(l.type, l.url)} target="_blank" rel="noreferrer" style={linkRow}>
                <span>{SOCIAL_LABELS[l.type] || l.type}</span> <span style={{ ...iconBubble, marginInlineStart: 'auto' }}>{SOCIAL_ICONS[l.type] || '🔗'}</span>
              </a>
            ))}
          </div>

          <a href={`/api/portal/card/company/${slug}/vcard`} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, marginTop: 24, padding: '14px 0', borderRadius: 14, background: `linear-gradient(225deg,${theme.primary},${theme.accent})`, color: 'white', fontWeight: 700, fontSize: '0.95rem', textDecoration: 'none', boxShadow: '0 6px 16px rgba(0,0,0,0.25)' }}>
            <IconAddContact size={18} /> הוסף לאנשי קשר
          </a>
        </div>
      </div>
    </div>
  );
}
